import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=22f91c3e"
import script from "./TagsView.vue?vue&type=script&lang=ts"
export * from "./TagsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports